import { Button, EmptyState } from '@saniplus/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { HOME_PATH } from '../../app/config';

/**
 * What a route renders instead of itself when the caller lacks its permission.
 *
 * **Introuvable, never interdit.** This is the one screen every gate in the
 * portal uses, and it says exactly what the API says for the same request: a
 * 404 (AZ-1 — a 403 confirms that the thing behind it exists). Eight
 * hand-rolled copies of this used to live one per feature and had drifted into
 * four different sentences, three of which named the caller's role or their
 * missing permission; that is the leak the rule forbids, told politely.
 *
 * It is not a security control either — the API answers on its own. It exists
 * so the portal never leaves a typed URL blank, and it renders an explanation
 * rather than redirecting, because a silent bounce to the dashboard reads as a
 * broken link.
 */
export function PermissionFallback() {
  const { t } = useTranslation();

  return (
    <EmptyState
      headingLevel={2}
      title={t('errors.notFound.title')}
      description={t('errors.notFound.body')}
      action={
        <Button asChild variant="secondary">
          <Link to={HOME_PATH}>{t('errors.notFound.action')}</Link>
        </Button>
      }
    />
  );
}
